import Mock from 'mockjs';

const presetList = [
  {
    id: 1,
    name: 'workplace',
    title: '概览',
    icon: 'DashboardOutlined',
    badge: '',
    target: '_self',
    path: '/workplace',
    component: '@/pages/workplace',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 2,
    name: 'team',
    title: '团队管理',
    icon: 'SettingOutlined',
    badge: '',
    target: '_self',
    path: '/system',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 3,
    name: 'user',
    title: '成员列表',
    target: '_self',
    path: '/system/user',
    component: '@/pages/user',
    renderMenu: true,
    parent: 'team',
    permission: null,
    cacheable: true,
  },
  {
    id: 4,
    name: 'fans',
    title: '粉丝管理',
    icon: 'SettingOutlined',
    badge: '',
    target: '_self',
    path: '/fans',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 5,
    name: 'fanslist',
    title: '粉丝列表',
    target: '_self',
    path: '/fans/fans',
    component: '@/pages/fans',
    renderMenu: true,
    parent: 'fans',
    permission: null,
    cacheable: true,
  },
  {
    id: 6,
    name: 'star',
    title: '明星管理',
    icon: 'SettingOutlined',
    badge: '',
    target: '_self',
    path: '/star',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 7,
    name: 'starlist',
    title: '明星列表',
    target: '_self',
    path: '/star/star',
    component: '@/pages/star',
    renderMenu: true,
    parent: 'star',
    permission: null,
    cacheable: true,
  },
  {
    id: 6,
    name: 'comment',
    title: '评论管理',
    icon: 'SettingOutlined',
    badge: '',
    target: '_self',
    path: '/comment',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 7,
    name: 'commentlist',
    title: '评论列表',
    target: '_self',
    path: '/comment/comment',
    component: '@/pages/comment',
    renderMenu: true,
    parent: 'comment',
    permission: null,
    cacheable: true,
  },
  {
    id: 28,
    name: 'personal',
    title: '个人中心',
    path: '/personal',
    icon: 'ProfileOutlined',
    permission: null,
    component: '@/pages/personal',
    renderMenu: true,
    parent: null,
  },
  {
    id: 29,
    name: 'table',
    title: '表格',
    icon: 'TableOutlined',
    badge: '',
    target: '_self',
    path: '/table',
    component: '@/pages/table',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 30,
    name: 'interactive',
    title: '互动活动',
    icon: 'InteractionOutlined',
    badge: '',
    target: '_self',
    path: '/interactive',
    component: '@/components/layout/BlankView.vue',
    renderMenu: true,
    parent: null,
    permission: null,
    cacheable: true,
  },
  {
    id: 31,
    name: 'bulletwall-create',
    title: '新建弹幕墙',
    target: '_self',
    path: '/interactive/bulletwall/create',
    component: '@/pages/interactive/BulletWallCreate.vue',
    renderMenu: true,
    parent: 'interactive',
    permission: null,
    cacheable: true,
  },
  {
    id: 32,
    name: 'bulletwall-list',
    title: '查看弹幕',
    target: '_self',
    path: '/interactive/bulletwall/list',
    component: '@/pages/interactive/BulletWallList.vue',
    renderMenu: true,
    parent: 'interactive',
    permission: null,
    cacheable: true,
  },
  {
    id: 33,
    name: 'bulletwall-detail',
    title: '弹幕墙详情',
    target: '_self',
    path: '/interactive/bulletwall/detail/:id',
    component: '@/pages/interactive/BulletWallDetail.vue',
    renderMenu: false,
    parent: 'interactive',
    permission: null,
    cacheable: true,
  },
  {
    id: 34,
    name: 'bulletwall-edit',
    title: '编辑弹幕墙',
    target: '_self',
    path: '/interactive/bulletwall/edit/:id',
    component: '@/pages/interactive/BulletWallEdit.vue',
    renderMenu: false,
    parent: 'interactive',
    permission: null,
    cacheable: true,
  },

];

function getMenuList() {
  const menuStr = localStorage.getItem('stepin-menu');
  let menuList = [];
  if (!menuStr) {
    menuList = presetList;
    localStorage.setItem('stepin-menu', JSON.stringify(menuList));
  } else {
    menuList = JSON.parse(menuStr);
  }
  return menuList;
}

function saveMenu(menu) {
  const menuList = getMenuList();
  if (!menu.id) {
    menu.id = menuList.map((item) => item.id).reduce((p, c) => Math.max(p, parseInt(c)), 0) + 1;
  }
  const index = menuList.findIndex((item) => item.id === menu.id);
  if (index === -1) {
    menuList.push(menu);
  } else {
    menuList.splice(index, 1, menu);
  }
  localStorage.setItem('stepin-menu', JSON.stringify(menuList));
}

Mock.mock('api/menu', 'get', ({}) => {
  let menuList = getMenuList();
  const menuMap = menuList.reduce((p, c) => {
    p[c.name] = c;
    return p;
  }, {});
  menuList.forEach((menu) => {
    menu.renderMenu = !!menu.renderMenu;
    if (menu.parent) {
      const parent = menuMap[menu.parent];
      parent.children = parent.children ?? [];
      parent.children.push(menu);
    }
  });
  return {
    message: 'success',
    code: 0,
    data: menuList.filter((menu) => !menu.parent),
  };
});

Mock.mock('api/menu', 'put', ({ body }) => {
  const menu = JSON.parse(body);
  saveMenu(menu);
  return {
    code: 0,
    message: 'success',
  };
});

Mock.mock('api/menu', 'post', ({ body }) => {
  const menu = JSON.parse(body);
  saveMenu(menu);
  return {
    code: 0,
    message: 'success',
  };
});

Mock.mock('api/menu', 'delete', ({ body }) => {
  const id = body.get('id')[0];
  let menuList = getMenuList();
  const index = menuList.findIndex((menu) => menu.id === id);
  const [removed] = menuList.splice(index, 1);
  localStorage.setItem('stepin-menu', JSON.stringify(menuList));
  return {
    code: 0,
    message: 'success',
    data: removed,
  };
});
